import React from 'react'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {cssTheme} from '@vio/atlas/src/themes'
import {Text} from '@vio/atlas/Text'

import {PricePinTail} from './PricePinTail'

/** How far the bubble overlaps the tail, in px, so only its tip shows. */
const TAIL_OVERLAP = 12

// `transform` and `pointer-events` are outside Box's prop set.
const Root = styled.div`
  position: absolute;
  bottom: calc(100% + ${cssTheme.layout.spacing.s100});
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
`

/**
 * Label anchored above a bar by a downward-pointing tail. Positions itself
 * against the nearest positioned ancestor, so the caller owns the anchor.
 *
 * Wider than a bar, so on the first and last month it overhangs the chart.
 * Whatever wraps it has to allow that overflow.
 */
export const PricePin = ({children}: {children: React.ReactNode}) => (
  <Root>
    <Box
      position="relative"
      zIndex="1"
      paddingTop="s100"
      paddingBottom="s100"
      paddingLeft="s200"
      paddingRight="s200"
      marginBottom={`-${TAIL_OVERLAP}px`}
      backgroundColor="background.brand.primary"
      borderRadius="md"
      whiteSpace="nowrap"
    >
      <Text
        variant="labelXS"
        align="center"
        colorPath="content.neutral.inverse"
      >
        {children}
      </Text>
    </Box>
    <PricePinTail />
  </Root>
)
